import React from 'react';
import ResetPasswordSection from '../Components/ResetPassword';

const ResetPasswordPage = () => (
  <ResetPasswordSection />
);

export default ResetPasswordPage;
